exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flex_end[data-v-b2cd4a5a] {\n  display:flex;\n  justify-content: flex-end\n}\n", ""]);

// exports
